import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateMatchesStatus } from "@/api/matches";
import { MatchesQueryKeys } from "@/tanstackQuery/queries";
import { invalidateMatchLists } from "./invalidateMatchLists";

export const useUpdateMatchesStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMatchesStatus,
    onSuccess() {
      invalidateMatchLists(queryClient);
    },
  });
};
